import { generateUUID } from './common';
import { StoreAction, StoreContextState } from '../types';

export const reducer = (state: StoreContextState, action: StoreAction): StoreContextState => {
  switch (action.type) {
    case 'ADD_ALERT':
      action.payload.id = generateUUID();
      return {
        ...state,
        alerts: [
          ...state.alerts,
          action.payload
        ]
      };
    case 'REMOVE_ALERT':
      return {
        ...state,
        alerts: state.alerts.filter((o) => o.id !== action.payload)
      };
    case 'INIT_ALERTS':
      return {
        ...state,
        alerts: state.alerts.filter((o) => o.clear==='persist')
      };
    case 'ELEMENT_RADIO_SELECTED':
      return {
        ...state,
        selectedRadio: action.payload
      };
    case 'ELEMENT_SELECTION':
      return {
        ...state,
        selectedElement: action.payload
      };

    case 'BASE_MAP_SELECTION':
      return {
        ...state,
        selectedBaseMap: action.payload
      };
    case 'TOOL_BAR_OPEN':
      return {
        ...state,
        toolBarOpen: action.payload
      }

    case 'SET_COLOR_LEGEND':
      return {
        ...state,
        colorLegend: action.payload
      }
    case 'CREATE_TABLE':
      return {
        ...state,
        table: action.payload
      }

    case 'SELECT_TABLE_STATION':
      return {
        ...state,
        selectedStation: action.payload
      }

    case 'ALL_STATIONS':
      return {
        ...state,
        all_stations: action.payload
      }

    case 'SET_BOUNDARY':
      return{
        ...state,
        boundaries: action.payload
      }
    case 'SET_MID_DATE_SELECT':
      return{
        ...state,
        midDate: action.payload
      }
      case 'SET_DATES':
        return{
          ...state,
          dates: action.payload
        }

    case 'SET_WIND_DIRECTION':
      return{
        ...state,
        wind_direction: action.payload
      }

    case 'SET_WIND_SPEED':
      return{
        ...state,
        wind_speed: action.payload
      }

    case 'CALL_COMPLETED':
      return{
        ...state,
        callCompleted: action.payload
      }

    case 'STATION_CLICKED_ON_MAP':
      return{
        ...state,
        station_clicked_on_map: action.payload
      }
    case 'STATION_CLICKED':
      return{
        ...state,
        station_clicked: action.payload
      }
    case 'CURRENT_DATE':
      return{
        ...state,
        currentDate: action.payload
      }
    case 'CURRENT_SLIDER_DATE':
        return{
          ...state,
          currentSliderDate: action.payload
        }
    case 'CURRENT_ZOOM':
      return{
        ...state,
        currentZoom: action.payload
      }
    case 'WEATHER_OBS':
        return{
          ...state,
          currentWeatherObs: action.payload
        }
    case 'WXMINMAX':
        return{
          ...state,
          currentWXMinMax: action.payload
        }

    case 'FEATURES_RENDERED':
      return{
        ...state,
        currentFeaturesRendered: action.payload
      }
      case 'SET_FILTERS':
        return{
          ...state,
          filters: action.payload
        }
    case 'SET_ELEVATION_FILTER':
      return{
        ...state,
        elevationFilterValues: action.payload
      }
    case 'SET_TIME_ZONE':
        return{
          ...state,
          userTimeZone: action.payload
    }
    case 'SET_INITIAL_LOAD':
      return{
        ...state,
        initialLoad: action.payload
  }
  case 'SET_CHART_TABLE':
    return{
      ...state,
      chartTable: action.payload
    }  
  case 'SET_POPUP_CONTENT':
      return{
        ...state,
        popupContent: action.payload
  }  
  case 'SET_LAT_LONG':
    return{
      ...state,
      latLong: action.payload
  } 

  case 'SET_SITE_TYPE':
    return{
      ...state,
      site_type: action.payload
  }
 case 'SET_GT05':
  return{
    ...state,
    GT05Displayed: action.payload
  }
  case 'SET_GT50':
    return{
      ...state,
      GT50Displayed: action.payload
    }
  case 'SET_SF100':
    return{
      ...state,
      SF100Displayed: action.payload
    }

  case 'SET_NOAA100':
    return{
      ...state,
      NOAA100Displayed: action.payload
    }
  case 'SET_PROD_BANNER':
    return{
      ...state,
      ProdBanner: action.payload
    }
  case 'SET_ALL_LEGEND':
      return{
        ...state,
        allLegend: action.payload
      }
  case 'SET_SEARCHED_STATION':
      return{
        ...state,
        stationSearched: action.payload
  }
  case 'SET_USER':
    return{
      ...state,
      user: action.payload
  }
  case 'SET_TOKENS':
    return{
      ...state,
      userTokens: action.payload
  }

  case 'SET_WEATHER_DATA':
    return{
      ...state,
      weatherData: action.payload
  }

  case 'SET_FS_START_DATE':
    return{
      ...state,
      fsMapStartDate: action.payload
  }

  case 'SET_FS_END_DATE':
    return{
      ...state,
      fsMapEndDate: action.payload
  }

  case 'SET_FS_FUEL':
    return{
      ...state,
      fsMapFuel: action.payload
  }

  case 'SET_FS_CATEGORY':
    return{
      ...state,
      fsMapCategory: action.payload
  }


  case 'SET_FS_METHOD':
    return{
      ...state,
      fsMapMethod: action.payload
  }

  case 'SET_FS_SUB_CAT':
    return{
      ...state,
      fsMapSubCat: action.payload
  }
  case 'SET_MAP_DATATYPE':
    return{
      ...state,
      mapDataType: action.payload
  }
  case 'NFDR_FUEL_MODEL_SELECTED':
    return{
      ...state,
      nfdrFuelModel: action.payload
  }

  case 'SET_SUB_CAT_LIST':
    return{
      ...state,
      subCatList: action.payload
  }
  case 'SET_METHOD_LIST':
    return{
      ...state,
      methodList: action.payload
  }
  case 'SET_CATEGORY_LIST':
    return{
      ...state,
      categoryList: action.payload
  }
  case 'SET_FUEL_LIST':
    return{
      ...state,
      fuelList: action.payload
  }

  case 'SET_SEASONAL_TREND_CHARTS':
    return{
      ...state,
      seasonalTrend: action.payload
  }
  case 'SET_NETWORK':
    return{
      ...state,
      network: action.payload
  }
  case 'SET_OPEN_CALC':
    return{
      ...state,
      openCalc: action.payload
  }

  default:
      return state;
  }
};
